import { useBoolean } from 'hooks';
import { useEffect } from 'react';

type UserFilterActionsParams<T> = {
    filters: T;
    initialFilters: T;
    defaultFilters: T;
    setFilters: React.Dispatch<React.SetStateAction<T>>;
    setFiltersContext: React.Dispatch<React.SetStateAction<T>>;
};

export const useFilterActions = <T extends Record<string, unknown>>(params: UserFilterActionsParams<T>) => {
    const { filters, initialFilters, defaultFilters, setFilters, setFiltersContext } = params;
    const { value: isDrawerOpen, toggle: toggleDrawer } = useBoolean(false);
    const handleApplyFilters = () => setFiltersContext(filters);
    const handleClear = (key?: keyof T) => () => {
        if (key) {
            setFilters(prev => ({
                ...prev,
                [key]: defaultFilters[key]
            }));
        } else {
            setFilters(defaultFilters);
            setFiltersContext(defaultFilters);
            toggleDrawer();
        }
    };
    const handleChange = (key: keyof T) => (value: T[typeof key]) =>
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    const handleSearchQueryChange = (searchQuery: string) => {
        // @ts-expect-error
        handleChange('searchQuery')(searchQuery);
        setFiltersContext(prev => ({
            ...prev,
            searchQuery
        }));
    };

    useEffect(() => {
        isDrawerOpen && setFilters(initialFilters);
    }, [isDrawerOpen]);

    return {
        isDrawerOpen,
        toggleDrawer,
        filters,
        handleApplyFilters,
        handleClear,
        handleChange,
        handleSearchQueryChange
    };
};
